import moment from 'moment';

export const toDateOnly = (value) => {
    if (value == null || value === '') return null;
    if (moment.isMoment(value)) {
        if (!value.isValid()) return null;
        return moment.utc([value.year(), value.month(), value.date()]).startOf('day').toISOString();
    }
    const utc = moment.utc(value);
    return utc.isValid() ? utc.startOf('day').toISOString() : null;
};

export const toDateMoment = (value) => (value ? moment.utc(value) : null);

export const formatDate = (date) => {
    if (!date) return '';
    return moment.utc(date).format('MMM D, YYYY');
}

export const formatDateTime = (date) => {
    if (!date) return '';
    return moment.utc(date).local().format('MMM D, YYYY, HH:mm');
};

export const formatFormExpirationDate = (date) => {
    if (!date) return '';
    return moment.utc(date).local().format('MMM D, YYYY, HH:mm z');
};

export const toFormExpirationMoment = (date) => (date ? moment.utc(date).local() : null);

export const toFormExpirationIso = (value) => {
    if (!value) return null;

    return value.clone().utc().seconds(0).milliseconds(0).toISOString();
};

export const isDateExpired = dateToCheck => {
    const date = new Date(dateToCheck);
    const currentDate = new Date();

    return date < currentDate;
};
